import { Heading } from "components/designV2/heading/heading";
import { Text } from "components/designV2/text/text";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const LoggedOutPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoginContentWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const FormStyled = styled.form`
  width: 100%;
  max-width: none;
  padding: 0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledTitle = styled(Heading).attrs({
  level: "h3",
  margin: "0",
})`
  text-align: left;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  button {
    margin-top: 0;
  }
`;

export const ErrorText = styled(Text).attrs({
  typography: "s1",
  color: ColorV2.NegativeRed,
})`
  margin: 0;
`;

export const CreateCompanyRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.md}px;
`;

export const CreateCompanyLink = styled.button`
  ${TypographyV2.b1}
  background: transparent;
  border: none;
  padding: 0;
  color: ${ColorV2.Blue1};
  text-decoration: underline;
  cursor: pointer;
`;

export const PageActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Spacing.md}px;
  margin-top: ${Spacing.lg}px;
  justify-content: center;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 370px;
  background-color: ${ColorV2.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
  button {
    ${TypographyV2.b2}
  }
  h4 {
    margin: 10px 0;
  }
  p {
    margin: 0 0 40px 0;
  }
`;

export const ForgotPasswordRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.lg}px;
`;

export const ForgotPasswordButton = styled.button`
  ${TypographyV2.b1}
  background: transparent;
  border: none;
  padding: 0;
  color: ${ColorV2.NegativeRed};
  text-decoration: underline;
  cursor: pointer;
`;
